import { Box } from "@mui/material";
import { useState } from "react";
import ChipTag from "../../../../../components/ChipTag";
import TagsDropdown from "./TagsDropdown";

export default function TagChipWithDropDown({ tagKey, tagValue, entities }) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  return (
    <Box>
      <Box
        onClick={(event) => setMenuAnchorEl(event.currentTarget)}
        sx={{ cursor: "pointer" }}
      >
        <ChipTag tagKey={tagKey} tagValue={tagValue} />
      </Box>
      {menuAnchorEl && (
        <TagsDropdown
          selectedEntities={entities}
          menuAnchorEl={menuAnchorEl}
          setMenuAnchorEl={setMenuAnchorEl}
        />
      )}
    </Box>
  );
}
